import React, { useEffect, useRef } from "react";
import euLogo from "../../images/eu-logo.png";
import snazniLogo from "../../images/snazni169.png";
import ministarstvoLogo from "../../images/ministarstvo.png";
import resilienceLogo from "../../images/resilience169.png";
import StripeSvg from "../svgs/Stripe/Stripe";
import {
  footer,
  stripe,
  inner,
  logos,
  disclaimer,
} from "./Footer.module.scss";
import useLang from "../../contexts/Language/LanguageContext";
import translate from "../../utils/lang/langHash";

const partnerLogos = {
  mne: { src: snazniLogo, width: 320 },
  en: { src: resilienceLogo, width: 319 },
};

export default function Footer() {
  const lang = useLang();
  const ref = useRef();
  useEffect(() => {
    const el = ref.current;
    const root = document.documentElement;
    const observer = new ResizeObserver(() =>
      root.style.setProperty("--fh", `${el.offsetHeight}px`)
    );
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.setProperty("--fh", "0px");
    };
  }, []);
  const partner = partnerLogos[lang];
  return (
    <footer ref={ref} className={footer}>
      <StripeSvg className={stripe} />
      <div className={inner}>
        <div className={logos}>
          <img
            src={partner.src}
            alt={translate("footer-partner", lang)}
            width={partner.width}
            height="180"
          />
          <img
            src={ministarstvoLogo}
            alt={translate("footer-ministry", lang)}
            width="414"
            height="135"
          />
          <img
            src={euLogo}
            alt={translate("footer-eu", lang)}
            width="273"
            height="180"
          />
        </div>
        <p className={disclaimer}>{translate("disclaimer", lang)}</p>
      </div>
    </footer>
  );
}
